module.exports = __webpack_public_path__ + "static/media/UK.51d75ea4.svg";